<div class="dropdown-container">
  <button
    class="dropdown"
    tabIndex="0"
    (blur)="onBlur($event)"
    (click)="showMenu()"
    (keypress)="onDropdownKeypress($event)"
  >
      <span class="label" *ngIf="label">{{ label?.length ? label : ''}}<span class="required-asterisk" *ngIf="required"> *</span></span>
    <button (click)="showMenu()" class="value">{{ choice[key] }}</button>
    <button
      alt="Menu Button"
      class="value"
      (click)="showMenu()"
      focusable="false"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        >
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
      </svg>
    </button>
  </button>
  <div id="menu" class="menu" *ngIf="showingMenu">
    <button
      class="menu-option"
      tabIndex="0"
      (click)="select(option)"
      (keypress)="onMenuOptionKeypress(option, $event)"
      *ngFor="let option of options"
      >{{ option[key] }}</button
    >
  </div>
</div>
